import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./SideMenu.css";

export const SideMenuBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [directoryOpen, setDirectoryOpen] = useState(
    location.pathname === "/SiteDatabase" || location.pathname === "/EmployeeDatabase"
  );
  const [mobileOpen, setMobileOpen] = useState(false);

  const menuItems = [
    {
      path: "/Dashboard",
      label: "Dashboard",
      icon: "../assets/dashboard.png",
    },
    {
      path: "/ListView",
      label: "Tasks",
      icon: "../assets/tasks.png",
    },
    {
      path: "/CalendarPage",
      label: "Calendar",
      icon: "../assets/calendar.png",
    },
    {
      path: "/PerformancePage",
      label: "Performance",
      icon: "../assets/performance.png",
    },
    {
      path: "/UserControl",
      label: "User Control",
      icon: "../assets/users.png",
    },
  ];

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    try {
      sessionStorage.removeItem("user");
      window.location.href = "/SignIn";
    } catch (error) {
      console.error("Error removing user data from session:", error);
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className={`mobile_menu_trigger ${mobileOpen ? "is_open" : ""}`}
        onClick={() => setMobileOpen((prev) => !prev)}
        aria-label={mobileOpen ? "Close navigation" : "Open navigation"}
        aria-expanded={mobileOpen}
      >
        <span />
        <span />
        <span />
      </button>

      {mobileOpen && (
        <div
          className="sidebar_mobile_overlay"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      <aside className={`sidebar2 ${mobileOpen ? "mobile_open" : ""}`}>
        <div className="sidebar_brand">
          <button
            type="button"
            className="sidebar_logo_button"
            onClick={() => handleNavigate("/Dashboard")}
            aria-label="Go to dashboard"
          >
            <img
              className="logo_img"
              src="../assets/logo-no-background.png"
              alt="Logo"
            />
          </button>

          <button
            type="button"
            className="mobile_close_button"
            onClick={() => setMobileOpen(false)}
            aria-label="Close navigation"
          >
            ×
          </button>
        </div>

        <div className="sidebar_workspace">
          <span className="workspace_dot" />
          <div>
            <strong>Workspace</strong>
            <small>Operations Hub</small>
          </div>
          <span className="workspace_chevron">⌄</span>
        </div>

        <div className="sidebar_section_label">Workspace</div>

        <nav className="sidebar_nav" aria-label="Main navigation">
          {menuItems.map((item) => (
            <button
              key={item.path}
              type="button"
              className={`menu_btn1 ${isActive(item.path) ? "is_active" : ""}`}
              onClick={() => handleNavigate(item.path)}
              aria-current={isActive(item.path) ? "page" : undefined}
            >
              <span className="menu_icon">
                <img src={item.icon} alt="" />
              </span>
              <span className="menu_text1">{item.label}</span>
              {isActive(item.path) && <span className="active_indicator" />}
            </button>
          ))}

          <div className="directory_wrapper">
            <button
              type="button"
              className={`directory_menu_btn1 ${
                directoryOpen ||
                isActive("/SiteDatabase") ||
                isActive("/EmployeeDatabase")
                  ? "is_active"
                  : ""
              }`}
              onClick={() => setDirectoryOpen((prev) => !prev)}
              aria-expanded={directoryOpen}
              aria-controls="directory-submenu"
            >
              <span className="menu_icon">
                <img src="../assets/directory.png" alt="" />
              </span>
              <span className="menu_text1">Directory</span>
              <span className={`directory_chevron ${directoryOpen ? "expanded" : ""}`}>
                ›
              </span>
            </button>

            <div
              id="directory-submenu"
              className={`tooltip-content1 ${directoryOpen ? "is_open" : ""}`}
            >
              <Link
                to="/SiteDatabase"
                className={isActive("/SiteDatabase") ? "sub_active" : ""}
                onClick={() => setMobileOpen(false)}
              >
                <span className="submenu_dot" />
                Site Database
              </Link>
              <Link
                to="/EmployeeDatabase"
                className={isActive("/EmployeeDatabase") ? "sub_active" : ""}
                onClick={() => setMobileOpen(false)}
              >
                <span className="submenu_dot" />
                Employee Database
              </Link>
            </div>
          </div>
        </nav>

        <div className="sidebar_section_label sidebar_bottom_label">System</div>

        <div className="sidebar_bottom">
          <button
            type="button"
            className={`menu_btn1 ${isActive("/SettingsPage") ? "is_active" : ""}`}
            onClick={() => handleNavigate("/SettingsPage")}
            aria-current={isActive("/SettingsPage") ? "page" : undefined}
          >
            <span className="menu_icon">
              <img src="../assets/setting.png" alt="" />
            </span>
            <span className="menu_text1">Settings</span>
            {isActive("/SettingsPage") && <span className="active_indicator" />}
          </button>

          <button
            type="button"
            className="menu_btn1 logout_button"
            onClick={handleLogout}
          >
            <span className="menu_icon">
              <img src="../assets/logout.png" alt="" />
            </span>
            <span className="menu_text1">Logout</span>
          </button>
        </div>

        <div className="sidebar_footer">
          <span className="footer_status" />
          <span>System online</span>
          <span className="footer_version">v2.0</span>
        </div>
      </aside>
    </>
  );
};

export default SideMenuBar;
